export const environment = {
  env: 'staging',
  enableProdMode: false,
  enableAnalyticsDebug: true,
  enableDatadogRum: true,
  baseUrl: 'https://product-management.ui.stage.ngin-staging.com',
  production: false,
  apiBaseUrl: 'https://api.stage.ngin-staging.com',
  assetService: 'https://attachments.se-stage-assets.com/',
  clareApiUrl: 'https://clare-accounting.stage.ngin-staging.com',
  clareOnboardingUrl: 'https://api.stage.ngin-staging.com',
  commerceApiUri: 'https://api.stage.ngin-staging.com/v3/commerce',
  registrationAdminUrl: 'https://admin.stage.ngin-staging.com/site_admin/org_redirect',
  domainEnvironments: [
    {
      domain: 'sestage.us',
      default: true,
      urls: {
        api: 'https://se-api.sestage.us',
      },
    },
    {
      domain: 'stage.ngin-staging.com',
      default: false,
      urls: {
        api: 'https://api.stage.ngin-staging.com',
      },
    },
  ],
  seFeFrameRouterOrigin: [
    'https://app.stage.ngin-staging.com',
    'https://org.stage.ngin-staging.com',
    'https://org.ui.stage.ngin-staging.com',
  ],
  seFeFrameRouterRedirectUrl: 'https://org.stage.ngin-staging.com/org/:orgId/*',
};
